<template>
<div class="chapter">
<div class="inner_page">
<p class="C841"><span class="small"><span id="page_2">POS</span>SIBLE PSALM</span></p>
<p class="C852">When I saw light the sculptor chiseling sheer bluff</p>
<p class="C854">from slope—the cleaved wood landing as shadow</p>
<p class="C854">in down-mountain saddles, a coarse grit teasing out</p>
<p class="C854">the basalt’s facelike features, then finer grains</p>
<p class="C854">crazing the air with duff—</p>
<p class="C852">I said aloud <em>good light:</em> as if it were dog or obedient</p>
<p class="C854">child, as if there were some other kind. As if it had not by then</p>
<p class="C854">vanished into that antipodal room, the work shrouded in dark sheet.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Possible.vue?680b5d95